module.exports = __webpack_public_path__ + "images/969d86a8d06626bf74c82ed60e766ab4.svg";